import script from "./CrudOperadores.vue?vue&type=script&setup=true&lang=js"
export * from "./CrudOperadores.vue?vue&type=script&setup=true&lang=js"

import "./CrudOperadores.vue?vue&type=style&index=0&id=63e32c46&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63e32c46"]])

export default __exports__